import PropTypes from 'prop-types';

export default {
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  resetPassword: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      sent: PropTypes.bool
    })
  })
};
